import { render, staticRenderFns } from "./actionColumnPosition-editor.vue?vue&type=template&id=4ce72e3f&scoped=true&"
import script from "./actionColumnPosition-editor.vue?vue&type=script&lang=js&"
export * from "./actionColumnPosition-editor.vue?vue&type=script&lang=js&"
import style0 from "./actionColumnPosition-editor.vue?vue&type=style&index=0&id=4ce72e3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce72e3f",
  null
  
)

export default component.exports